export default "/videos/0debe4d995da24a2936569f8e9fde103.mp4";